/* tslint:disable */
/* eslint-disable */
/**
 * K1 OpenAPI
 * API fuer die Nutzung der K1 REST-Schnittstelle
 *
 * The version of the OpenAPI document: 1.168.0-SNAPSHOT
 * Contact: diplan-backend@init.de
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { ErrorRest } from '../models';
// @ts-ignore
import type { TransferMessageDetailRest } from '../models';
// @ts-ignore
import type { VerfahrenUebersichtMetadatenRest } from '../models';
/**
 * MetadatenExportResourceApi - axios parameter creator
 * @export
 */
export const MetadatenExportResourceApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * <b>Beschreibung:</b><p>Mit diesem Endpunkt werden alle Verfahren die innerhalb der angegebenen Geometrie liegen zurückgeliefert.<br> Die Geometrie muss als GeoJson mit Koordinatensystem WKS84 übergeben werden.</p><p><b>Benötigte Rechte:</b> VERFAHREN_READ or EIGENE_VERFAHREN_READ or ADMIN</p>
         * @summary Endpunkt der alle Verfahren innerhalb einer gegebenen Geometrie liefert.
         * @param {string} body Geometrie im Format GeoJson
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllVerfahrenInGeometry: async (body: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            assertParamExists('getAllVerfahrenInGeometry', 'body', body)
            const localVarPath = `/verfahren/metadaten/geometry`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwt-token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * <b>Beschreibung:</b><p>Mit diesem Endpunkt können Metadaten eines Verfahrens in spezifischen Formaten abgefragt werden.<br> Als Formate sind Beispielsweise DCAT-AP-PLU und CSW-T möglich.</p><p><b>Benötigte Rechte:</b> isAuthenticated()</p>
         * @summary Endpunkt zum Abfragen von Metadaten eines Verfahrens.
         * @param {string} planID PlanID vom Verfahren
         * @param {GetMetadatenFormat} format Ausgabeformat (z.B. DCAT-AP-PLU)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMetadaten: async (planID: string, format: GetMetadatenFormat, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'planID' is not null or undefined
            assertParamExists('getMetadaten', 'planID', planID)
            // verify required parameter 'format' is not null or undefined
            assertParamExists('getMetadaten', 'format', format)
            const localVarPath = `/verfahren/{planID}/metadaten`
                .replace(`{${"planID"}}`, encodeURIComponent(String(planID)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwt-token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (format !== undefined) {
                localVarQueryParameter['format'] = format;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * <b>Beschreibung:</b><p>Mit diesem Endpunkt wird für ein spezifisches Formt die Transfermessages für eine Verfahren erstellt.<br> Die Transfermessage wird dann von einem konfigurierbaren Job an das Zielsystem versendet.</p><p><b>Benötigte Rechte:</b> VERFAHREN_EINSTELLUNGEN or ADMIN</p>
         * @summary Endpunkt zum Erzeugen von TransferMessages für ein spezielles Ausgabeformat.
         * @param {string} planID PlanID vom Verfarhen
         * @param {PublishMetadatenFormat} format Ausgabeformat (z.B. DCAT-AP-PLU)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        publishMetadaten: async (planID: string, format: PublishMetadatenFormat, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'planID' is not null or undefined
            assertParamExists('publishMetadaten', 'planID', planID)
            // verify required parameter 'format' is not null or undefined
            assertParamExists('publishMetadaten', 'format', format)
            const localVarPath = `/verfahren/{planID}/metadaten`
                .replace(`{${"planID"}}`, encodeURIComponent(String(planID)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication jwt-token required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (format !== undefined) {
                localVarQueryParameter['format'] = format;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * MetadatenExportResourceApi - functional programming interface
 * @export
 */
export const MetadatenExportResourceApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = MetadatenExportResourceApiAxiosParamCreator(configuration)
    return {
        /**
         * <b>Beschreibung:</b><p>Mit diesem Endpunkt werden alle Verfahren die innerhalb der angegebenen Geometrie liegen zurückgeliefert.<br> Die Geometrie muss als GeoJson mit Koordinatensystem WKS84 übergeben werden.</p><p><b>Benötigte Rechte:</b> VERFAHREN_READ or EIGENE_VERFAHREN_READ or ADMIN</p>
         * @summary Endpunkt der alle Verfahren innerhalb einer gegebenen Geometrie liefert.
         * @param {string} body Geometrie im Format GeoJson
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllVerfahrenInGeometry(body: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<VerfahrenUebersichtMetadatenRest>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllVerfahrenInGeometry(body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MetadatenExportResourceApi.getAllVerfahrenInGeometry']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * <b>Beschreibung:</b><p>Mit diesem Endpunkt können Metadaten eines Verfahrens in spezifischen Formaten abgefragt werden.<br> Als Formate sind Beispielsweise DCAT-AP-PLU und CSW-T möglich.</p><p><b>Benötigte Rechte:</b> isAuthenticated()</p>
         * @summary Endpunkt zum Abfragen von Metadaten eines Verfahrens.
         * @param {string} planID PlanID vom Verfahren
         * @param {GetMetadatenFormat} format Ausgabeformat (z.B. DCAT-AP-PLU)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMetadaten(planID: string, format: GetMetadatenFormat, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMetadaten(planID, format, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MetadatenExportResourceApi.getMetadaten']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * <b>Beschreibung:</b><p>Mit diesem Endpunkt wird für ein spezifisches Formt die Transfermessages für eine Verfahren erstellt.<br> Die Transfermessage wird dann von einem konfigurierbaren Job an das Zielsystem versendet.</p><p><b>Benötigte Rechte:</b> VERFAHREN_EINSTELLUNGEN or ADMIN</p>
         * @summary Endpunkt zum Erzeugen von TransferMessages für ein spezielles Ausgabeformat.
         * @param {string} planID PlanID vom Verfarhen
         * @param {PublishMetadatenFormat} format Ausgabeformat (z.B. DCAT-AP-PLU)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async publishMetadaten(planID: string, format: PublishMetadatenFormat, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TransferMessageDetailRest>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.publishMetadaten(planID, format, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MetadatenExportResourceApi.publishMetadaten']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * MetadatenExportResourceApi - factory interface
 * @export
 */
export const MetadatenExportResourceApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = MetadatenExportResourceApiFp(configuration)
    return {
        /**
         * <b>Beschreibung:</b><p>Mit diesem Endpunkt werden alle Verfahren die innerhalb der angegebenen Geometrie liegen zurückgeliefert.<br> Die Geometrie muss als GeoJson mit Koordinatensystem WKS84 übergeben werden.</p><p><b>Benötigte Rechte:</b> VERFAHREN_READ or EIGENE_VERFAHREN_READ or ADMIN</p>
         * @summary Endpunkt der alle Verfahren innerhalb einer gegebenen Geometrie liefert.
         * @param {string} body Geometrie im Format GeoJson
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllVerfahrenInGeometry(body: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<VerfahrenUebersichtMetadatenRest>> {
            return localVarFp.getAllVerfahrenInGeometry(body, options).then((request) => request(axios, basePath));
        },
        /**
         * <b>Beschreibung:</b><p>Mit diesem Endpunkt können Metadaten eines Verfahrens in spezifischen Formaten abgefragt werden.<br> Als Formate sind Beispielsweise DCAT-AP-PLU und CSW-T möglich.</p><p><b>Benötigte Rechte:</b> isAuthenticated()</p>
         * @summary Endpunkt zum Abfragen von Metadaten eines Verfahrens.
         * @param {string} planID PlanID vom Verfahren
         * @param {GetMetadatenFormat} format Ausgabeformat (z.B. DCAT-AP-PLU)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMetadaten(planID: string, format: GetMetadatenFormat, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.getMetadaten(planID, format, options).then((request) => request(axios, basePath));
        },
        /**
         * <b>Beschreibung:</b><p>Mit diesem Endpunkt wird für ein spezifisches Formt die Transfermessages für eine Verfahren erstellt.<br> Die Transfermessage wird dann von einem konfigurierbaren Job an das Zielsystem versendet.</p><p><b>Benötigte Rechte:</b> VERFAHREN_EINSTELLUNGEN or ADMIN</p>
         * @summary Endpunkt zum Erzeugen von TransferMessages für ein spezielles Ausgabeformat.
         * @param {string} planID PlanID vom Verfarhen
         * @param {PublishMetadatenFormat} format Ausgabeformat (z.B. DCAT-AP-PLU)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        publishMetadaten(planID: string, format: PublishMetadatenFormat, options?: RawAxiosRequestConfig): AxiosPromise<TransferMessageDetailRest> {
            return localVarFp.publishMetadaten(planID, format, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * MetadatenExportResourceApi - object-oriented interface
 * @export
 * @class MetadatenExportResourceApi
 * @extends {BaseAPI}
 */
export class MetadatenExportResourceApi extends BaseAPI {
    /**
     * <b>Beschreibung:</b><p>Mit diesem Endpunkt werden alle Verfahren die innerhalb der angegebenen Geometrie liegen zurückgeliefert.<br> Die Geometrie muss als GeoJson mit Koordinatensystem WKS84 übergeben werden.</p><p><b>Benötigte Rechte:</b> VERFAHREN_READ or EIGENE_VERFAHREN_READ or ADMIN</p>
     * @summary Endpunkt der alle Verfahren innerhalb einer gegebenen Geometrie liefert.
     * @param {string} body Geometrie im Format GeoJson
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MetadatenExportResourceApi
     */
    public getAllVerfahrenInGeometry(body: string, options?: RawAxiosRequestConfig) {
        return MetadatenExportResourceApiFp(this.configuration).getAllVerfahrenInGeometry(body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * <b>Beschreibung:</b><p>Mit diesem Endpunkt können Metadaten eines Verfahrens in spezifischen Formaten abgefragt werden.<br> Als Formate sind Beispielsweise DCAT-AP-PLU und CSW-T möglich.</p><p><b>Benötigte Rechte:</b> isAuthenticated()</p>
     * @summary Endpunkt zum Abfragen von Metadaten eines Verfahrens.
     * @param {string} planID PlanID vom Verfahren
     * @param {GetMetadatenFormat} format Ausgabeformat (z.B. DCAT-AP-PLU)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MetadatenExportResourceApi
     */
    public getMetadaten(planID: string, format: GetMetadatenFormat, options?: RawAxiosRequestConfig) {
        return MetadatenExportResourceApiFp(this.configuration).getMetadaten(planID, format, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * <b>Beschreibung:</b><p>Mit diesem Endpunkt wird für ein spezifisches Formt die Transfermessages für eine Verfahren erstellt.<br> Die Transfermessage wird dann von einem konfigurierbaren Job an das Zielsystem versendet.</p><p><b>Benötigte Rechte:</b> VERFAHREN_EINSTELLUNGEN or ADMIN</p>
     * @summary Endpunkt zum Erzeugen von TransferMessages für ein spezielles Ausgabeformat.
     * @param {string} planID PlanID vom Verfarhen
     * @param {PublishMetadatenFormat} format Ausgabeformat (z.B. DCAT-AP-PLU)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MetadatenExportResourceApi
     */
    public publishMetadaten(planID: string, format: PublishMetadatenFormat, options?: RawAxiosRequestConfig) {
        return MetadatenExportResourceApiFp(this.configuration).publishMetadaten(planID, format, options).then((request) => request(this.axios, this.basePath));
    }
}

/**
 * @export
 */
export const GetMetadatenFormat = {
    DCAT_AP_PLU: 'DCAT_AP_PLU',
    DCAT_AP_EIA: 'DCAT_AP_EIA',
    CSW: 'CSW',
    CSW_T: 'CSW_T',
    XPLAN_LP: 'XPLAN_LP',
    XPLAN_BP: 'XPLAN_BP',
    XPLAN_FP: 'XPLAN_FP',
    XPLAN_RP: 'XPLAN_RP',
    XPLAN_SO: 'XPLAN_SO',
    XTRASSE: 'XTRASSE'
} as const;
export type GetMetadatenFormat = typeof GetMetadatenFormat[keyof typeof GetMetadatenFormat];
/**
 * @export
 */
export const PublishMetadatenFormat = {
    DCAT_AP_PLU: 'DCAT_AP_PLU',
    DCAT_AP_EIA: 'DCAT_AP_EIA',
    CSW: 'CSW',
    CSW_T: 'CSW_T',
    XPLAN_LP: 'XPLAN_LP',
    XPLAN_BP: 'XPLAN_BP',
    XPLAN_FP: 'XPLAN_FP',
    XPLAN_RP: 'XPLAN_RP',
    XPLAN_SO: 'XPLAN_SO',
    XTRASSE: 'XTRASSE'
} as const;
export type PublishMetadatenFormat = typeof PublishMetadatenFormat[keyof typeof PublishMetadatenFormat];
